






import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import API from '@/Api';
const namespace: string = 'AppStore';

@Component
export default class WelcomeBoard extends Vue {
    @Getter('name', { namespace }) public name!: string;
    get greeting() {
        const d = new Date();
        const n = d.getHours();
        if (n < 12) {
            return 'Good Morning !';
        } else if (n < 16) {
            return 'Good Afternoon !';
        }
        return 'Good Evening !';
    }
}
